import React from 'react';
import {Folha} from '../../componentes/folha/folha';
const Relatorio = () => {
    return(<Folha>

        <h1>Relatorio</h1>
    </Folha>
    );
}

export {Relatorio};